import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DialogService, Destroy, Guard, NullEntity, BreadCrumbService } from '@kpd/framework-ngx';
import { UserManagementEntityUpdater } from 'app/shared/services/entity-updater';
import { PermissionsetFacade } from 'app/shared/services/facades/permissionset.facade';
import { PermissionsetsNavigatorHelper } from 'app/permissionsets/permissionsets-navigator-helper';
import { Permissionset } from 'app/shared/models/permissionset';
import { ViewMode } from '@kpd/framework-ngx';
import { PermissionsetService } from 'app/shared/services/permissionset.service';
import { PermissionsetKey } from 'app/shared/models/keys/permissionset-key';

@Component({
  selector: 'app-permission-sets-details',
  templateUrl: './permissionset-details.component.html',
})
export class PermissionsetDetailsComponent implements OnInit, OnDestroy {
  currentItem: Permissionset | NullEntity = new Permissionset();
  entityUpdater: UserManagementEntityUpdater;
  viewMode = ViewMode.Consult;
  tabLabels = { permissionCount: 0 };
  keyOfPermissionSetToCopy: string;
  canManage = true;

  @Destroy()
  destroy$: any;

  constructor(
    dialogService: DialogService,
    guard: Guard,
    private permissionsetService: PermissionsetService,
    public navigatorHelper: PermissionsetsNavigatorHelper,
    public permissionSetFacade: PermissionsetFacade,
    private route: ActivatedRoute,
    breadCrumbService: BreadCrumbService,
  ) {
    this.entityUpdater = new UserManagementEntityUpdater(
      dialogService,
      this.navigatorHelper,
      this.permissionSetFacade,
      guard,
      breadCrumbService,
      'permissionsets',
    );
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.viewMode = params['mode'];
      this.keyOfPermissionSetToCopy = params['copy'];
    });
  }

  onClose(): void {
    this.navigatorHelper.back();
  }

  onItemChanged(event: Permissionset): void {
    if (event instanceof NullEntity) {
      this.canManage = true;
      this.currentItem = new Permissionset();
      return;
    }
    if (event.permissions) {
      this.changeTabLabel('permissionCount', event.permissions.length);
    }
    this.currentItem = event;
    this.checkToEdit();
  }

  private checkToEdit(): void {
    this.canManage = true;
    if (!this.currentItem.key) {
      return;
    }
    this.permissionsetService
      .canManage(this.currentItem.key as PermissionsetKey)
      .subscribe(result => (this.canManage = result));
  }

  onSwitchMode(mode: string): void {
    this.navigatorHelper.navigateByQueryString({ tab: this.route.snapshot.queryParams['tab'], mode });
  }

  changeTabLabel(tab: string, amount: number): void {
    this.tabLabels[tab] = amount;
  }

  ngOnDestroy(): void {
    this.entityUpdater.destroy();
  }
}
